import type { DemoSlotsTrackerMetrics } from '@ts-demo-slot/interfaces'
import type { ApiCallbacks } from '@utils/api/run-api-get'

import { useDemoShiftControlStore } from '@stores/demo-shift-control'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

import { runApiGet } from '@utils/api/run-api-get'

type SlotsTrackerMetricsApiOptions = ApiCallbacks<DemoSlotsTrackerMetrics>

export const useSlotsTrackerMetricsApi = async (options?: SlotsTrackerMetricsApiOptions): Promise<DemoSlotsTrackerMetrics | null> => {
  const demoShiftControlStore = useDemoShiftControlStore()
  const url = useAdminRoutes('admin.demo-slots.metrics')

  return runApiGet<DemoSlotsTrackerMetrics>(url, {
    setLoading: (loading) => demoShiftControlStore.setLoading(loading),
    handle: (response) => {
      const metrics: DemoSlotsTrackerMetrics | null = response?.data?.metrics || null
      demoShiftControlStore.setMetrics(metrics)
      return metrics
    },
    hooks: options,
  })
}
